//error handling
if (document.querySelector('form[id^="product_form_"]')){
    
    window.addEventListener('load', checkboxListener);

}

function checkboxListener(){

    if (document.querySelector('.hulkapps_mswatch_option')){

        let checkboxes = document.querySelectorAll('.hulkapps_mswatch_option');

        for (i=0;i<checkboxes.length;i++){
            checkboxes[i].addEventListener('click', checkLines);
        }

    }

}

function checkLines(){
    
    let line = document.querySelectorAll('.wrap_nameplate');
    let match = [];

    for (i=0;i<line.length;i++){

        let a = line[i].classList.contains('condition_show');
        let b = line[i].classList.contains('wrap_nameplate');
        let x = line[i].classList.contains('conditional');
        let y = line[i].classList.contains('hide');

        if (a && b){

            if ((x && y) || (!x && !y)){
            
                match.push(line[i]);

            } else {

                if (x && !y){
                    
                    line[i].classList.remove('hide');

                    if ((x && y) || (!x && !y)){
                        match.push(line[i]);
                    }
                
                } else if (!x && y){
                    
                    line[i].classList.add('hide');
                    
                    if ((x && y) || (!x && !y)){
                        match.push(line[i]);
                    }
                }
            }
        }
    }
}